/**
 * Get CSS transform for media based on position and scale adjustments
 */
export const getMediaTransform = (mediaItem: { position?: { x: number; y: number }; scale?: { scaleX: number; scaleY: number } } | null): string => {
  if (!mediaItem) return '';
  
  const position = mediaItem.position || { x: 0, y: 0 };
  const scale = mediaItem.scale || { scaleX: 1, scaleY: 1 };
  
  return `translate(${position.x}%, ${position.y}%) scale(${scale.scaleX}, ${scale.scaleY})`;
};

/**
 * Get transform origin for media scaling
 */
export const getTransformOrigin = (): string => {
  return 'center center';
};
